import React, { useRef, useEffect } from 'react';
import { cn } from '@/lib/utils';

export interface TypeTabItem {
  key: number | string;
  label: React.ReactNode;
}

interface TypeTabsProps {
  tabs: TypeTabItem[];
  activeKey: number | string;
  onChange: (key: number | string) => void;
  className?: string;
  labelClassName?: string;
}

export const SlidingTabs: React.FC<TypeTabsProps> = ({
  tabs,
  activeKey,
  onChange,
  className,
  labelClassName,
}) => {
  const tabRefs = useRef<Record<number | string, HTMLButtonElement | null>>({});
  const indicatorRef = useRef<HTMLDivElement>(null);

  /** 更新 indicator 位置 */
  useEffect(() => {
    const activeTab = tabRefs.current[activeKey];
    const indicator = indicatorRef.current;

    if (!activeTab || !indicator) return;

    const { left, width } = activeTab.getBoundingClientRect();
    const containerLeft =
      activeTab.parentElement?.getBoundingClientRect().left || 0;

    indicator.style.transform = `translateX(${left - containerLeft}px)`;
    indicator.style.width = `${width}px`;
  }, [activeKey]);

  return (
    <div
      className={cn(
        'relative border-b border-[rgba(224,227,230,1)]',
        className,
      )}
    >
      <div className="flex overflow-x-auto scrollbar-hide gap-4">
        {tabs.map((tab) => (
          <button
            key={tab.key}
            ref={(el) => (tabRefs.current[tab.key] = el)}
            onClick={() => onChange(tab.key)}
            className={cn(
              'px-2 py-3 text-[15px] font-medium whitespace-nowrap transition-all outline-none',
              activeKey === tab.key
                ? 'text-[rgba(16,24,40,1)]'
                : 'text-[rgba(102,112,133,1)] hover:text-[#101828d4]',
              labelClassName,
            )}
          >
            {tab.label}
          </button>
        ))}
      </div>

      {/* 底部激活横条 */}
      <div
        ref={indicatorRef}
        className="absolute bottom-0 left-0 h-[2px] bg-[#101828] transition-all duration-300 ease-out"
        style={{ width: 0, transform: 'translateX(0)' }}
      />
    </div>
  );
};
